let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eoJuN")).then(() => parcelRequire('4rPC8'));